import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface ContestRegistration {
  id: string;
  category: string;
  class_level: string;
  class_name: string;
  participants_count: number;
  total_students_count: number;
  school_name: string;
  school_address: string;
  school_postal_code: string;
  school_city: string;
  school_phone: string;
  school_email: string;
  principal_name: string;
  teacher_name: string;
  teacher_function: string;
  teacher_phone: string;
  teacher_email: string;
  academy: string;
  created_at: string;
}

export const useContestData = () => {
  const [registrations, setRegistrations] = useState<ContestRegistration[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRegistrations = async () => {
      try {
        setIsLoading(true);
        const { data, error: fetchError } = await supabase
          .from('contest_registrations')
          .select('*')
          .order('created_at', { ascending: false });

        if (fetchError) throw fetchError;

        setRegistrations(data || []);
      } catch (err) {
        console.error("Error fetching contest registrations:", err);
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchRegistrations();
  }, []);

  return { registrations, isLoading, error };
};
